export default __webpack_public_path__ + "static/media/rocket_anim_67.f6c3280e.png";